import axios from "axios";
import React, { useState } from "react";
import { apiKey } from "../../config/config";
import { languageHelper } from "../../config/helperFunctions";

function POSHoldOrder({
  fetchOrders,
  setIsHoldModalOpen,
  holdOrders,
  setSelectedOrder,
  setSelectedOrderType,
  setOrderItemDetail,
  setIsUpdate,
}) {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const defaultLang = localStorage.getItem("rms-lang") || "text_en";
  const [selectOrder, setSelectOrder] = useState(null);

  const deleteOrder = () => {
    if (!selectOrder) {
      return;
    }

    axios
      .delete(`${apiKey}/api/rms/admin/deleteOrder/${selectOrder.id}`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setSelectOrder(null);
        fetchOrders();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const deleteHoldOrders = () => {
    axios
      .delete(`${apiKey}/api/rms/admin/deleteHoldOrder`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        setSelectOrder(null);
        fetchOrders();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleEditOrder = () => {
    if (!selectOrder) {
      return;
    }
    setSelectedOrder(selectOrder);
    setSelectedOrderType(selectOrder?.order_type_id);
    setOrderItemDetail(
      selectOrder?.order_details.map((item) => ({
        food_menu_name: item.name,
        food_menu_id: item.food_menu_id,
        food_menu_cooking_end_time: item.cooking_end_time,
        food_menu_cooking_start_time: item.cooking_start_time,
        food_menu_cooking_status: item.cooking_status,
        food_menu_note: item.menu_note,
        food_menu_qty: item.qty,
        food_menu_unit_price: item.menu_unit_price,
        food_menu_original_unit_price: item.menu_unit_price,
        food_menu_modifiers: item.food_menu.modifiers,
        food_menu_vat: item.menu_taxes.vat,
        food_menu_extra_vat: item.menu_taxes.additional_vat,
        food_menu_discount: item.menu_taxes.single_discount,
        food_menu_original_discount: item.menu_taxes.single_discount,
        food_menu_total_sale_price: item.menu_unit_price_with_vat,
        food_menu_after_discount:
          item.menu_unit_price - item.menu_taxes.single_discount,
        food_menu_modifier_selected: item.modifiers.map((mod) => ({
          modifier_id: mod.id,
          modifier_name: mod.name,
          modifier_price: mod.price,
          quantity: 1,
        })),
      }))
    );
    setIsUpdate(true);
    setIsHoldModalOpen(false);
  };
  return (
    <div className="w-full mx-auto bg-white shadow-md p-6 rounded-lg text-xs">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold">{languageHelper(defaultLang, "Hold Sale")}</h2>
        <button
          className="text-gray-500 hover:text-red-500"
          onClick={() => setIsHoldModalOpen(false)}
        >
          &times;
        </button>
      </div>

      <div className="flex space-x-4 mb-6">
        <div className="w-1/2">
          <table className="table-auto w-full border">
            <thead>
              <tr className="bg-d-bg text-white">
                <th className="px-4 py-2">{languageHelper(defaultLang, "Order Number")}</th>
                <th className="px-4 py-2">{languageHelper(defaultLang, "Customer")}</th>
                <th className="px-4 py-2">{languageHelper(defaultLang, "Table")}</th>
              </tr>
            </thead>
            <tbody>
              {holdOrders.map((order, index) => (
                <tr
                  key={index}
                  className="text-center hover:bg-gray-100 cursor-pointer"
                  onClick={() => setSelectOrder(order)}
                >
                  <td className="px-4 py-2">{order.sale_no}</td>
                  <td className="px-4 py-2">{order.customer?.name}</td>
                  <td className="px-4 py-2">{order.table?.name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="w-1/2">
          <h3 className="text-lg font-semibold">{languageHelper(defaultLang, "Order Details")}</h3>
          <div className="text-gray-700 mb-4">
            <p>
              {languageHelper(defaultLang, "Order Type")}:{" "}
              <span className="font-medium">{selectOrder?.customer?.name}</span>
            </p>
            <p>
              {languageHelper(defaultLang, "Waiter")}:{" "}
              <span className="font-medium">{selectOrder?.table?.name}</span>
            </p>
          </div>

          <table className="table-auto w-full border mb-4">
            <thead>
              <tr className="bg-d-bg text-white">
                <th className="px-4 py-2">{languageHelper(defaultLang, "Item")}</th>
                <th className="px-4 py-2">{languageHelper(defaultLang, "Price")}</th>
                <th className="px-4 py-2">{languageHelper(defaultLang, "Qty")}</th>
                <th className="px-4 py-2">{languageHelper(defaultLang, "Discount")}</th>
                <th className="px-4 py-2">{languageHelper(defaultLang, "Total")}</th>
              </tr>
            </thead>
            <tbody>
              {selectOrder?.order_details.map((order, index) => (
                <tr key={index} className="text-center">
                  <td className="px-4 py-2">{order.food_menu.name}</td>
                  <td className="px-4 py-2">
                    {order.menu_unit_price_with_vat}
                  </td>
                  <td className="px-4 py-2">{order.qty}</td>
                  <td className="px-4 py-2">
                    {order.menu_taxes.total_qty_discount}
                  </td>
                  <td className="px-4 py-2">
                    {parseFloat(
                      order.menu_taxes.total_qty_items_price.toFixed(2)
                    ) +
                      parseFloat(
                        order.menu_taxes.total_qty_vat.toFixed(2) +
                          parseFloat(order.menu_taxes.additional_vat)
                      )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="text-right text-gray-800 space-y-2">
            <p>
              {languageHelper(defaultLang, "Sub Total")}:{" "}
              <span className="font-medium">S.R {selectOrder?.sub_total}</span>
            </p>
            <p>
              {languageHelper(defaultLang, "Discount")}:{" "}
              <span className="font-medium">
                S.R {selectOrder?.total_discount_amount}
              </span>
            </p>
            <p>
              {languageHelper(defaultLang, "VAT")}:{" "}
              <span className="font-medium">S.R {selectOrder?.vat_amount}</span>
            </p>
            <p>
              {languageHelper(defaultLang, "Total Discount")}:{" "}
              <span className="font-medium">
                S.R {selectOrder?.total_item_discount_amount}
              </span>
            </p>
            <p>
              {languageHelper(defaultLang, "Service/Delivery Charges")}:{" "}
              <span className="font-medium">
                S.R {selectOrder?.delivery_charges}
              </span>
            </p>
            <p>
              {languageHelper(defaultLang, "Total Payable")}:{" "}
              <span className="font-medium">
                S.R {selectOrder?.total_payable}
              </span>
            </p>
          </div>
        </div>
      </div>

      <div className="flex justify-between">
        <button
          onClick={deleteHoldOrders}
          className="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
        >
          {languageHelper(defaultLang, "Delete all Hold Sales")}
        </button>
        <div className="space-x-2">
          <button
            onClick={() => setIsHoldModalOpen(false)}
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
          >
            {languageHelper(defaultLang, "Cancel")}
          </button>
          <button
            onClick={deleteOrder}
            className="bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
          >
            {languageHelper(defaultLang, "Delete")}
          </button>
          <button
            onClick={handleEditOrder}
            className="bg-d-cat-btn text-white px-4 py-2 rounded hover:bg-d-bg-dark"
          >
            {languageHelper(defaultLang, "Edit in Cart")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default POSHoldOrder;
